const splitProductTitle = (productTitle) => {
    let productNameArr = productTitle.split(" - "); // split product title into array
    
    if (productNameArr.length === 1 && productNameArr[0].includes(' – ')) { // watch for weird dash
        productNameArr = productTitle.split(" – ");
    }

    // if product title has more than 2 items, split the title into two lines
    if (productNameArr.length > 1) {
        productTitle = `
        <span class="split-product-title-family">${productNameArr[0]}</span>
        <span class="split-product-title-divider visually-hidden"> - </span>
        <span class="split-product-title-item">
        ${productNameArr.slice(1).join(" - ")}
        </span>
        `;
    }

    return productTitle;
}

const getRecentlyViewedProducts = () => {
    const productData = JSON.parse(localStorage.getItem("recentlyViewedProducts"));
    const recentlyViewedContainer = document.querySelector(".js-recently-viewed");
    const recentlyViewedHtml = [];

    const now = new Date();

    // compare now with productViewTimeStamp and only show products viewed in the allowed time
    const recentlyViewedMaxAge = Date.now() - (30 * 24 * 60 * 60 * 1000); // 30 days (move age setting to CMS)
    const siteRoot = window.Shopify.routes.root.slice(0, -1); // remove trailing slash
    const siteCurrency = window.Shopify.currency.active;

    if (productData.length > 0) {
        productData.map(item => {
            if (item.productId != window?.meta?.product?.id && item.productViewTimeStamp > recentlyViewedMaxAge) {
                const cleanUrl = `${siteRoot}/products/${item.productUrl.split('products/')[1]}`;
                recentlyViewedHtml.unshift(`
                <li class=" recently-viewed__item splide__slide">
                    <div class="recently-viewed__img"> 
                        <img src='${item.productImg}&width=300' loading="lazy" alt="${item.productTitle}"/>
                    </div>
                    <h3><a class="recently-viewed__link" href="${cleanUrl}">
                        ${splitProductTitle(item.productTitle)}
                    </a></h3>
                    ${siteCurrency === 'GBP' && item.productPrice.includes('£') ? `<div class="recently-viewed__price">${item.productPrice}</div>` : ''}
                </li>
                `);
            }
        });

        if (recentlyViewedHtml.length > 0) { // ensure we have products in the array before adding the title
            recentlyViewedHtml.unshift('<section class="splide" id="splide-recently-viewed"><div class="splide__track"><ul class="splide__list" role="list">');
            recentlyViewedHtml.push('</ul></div></section>');
            recentlyViewedHtml.unshift(`<h2 class="title h1 center">${recentlyViewedContainer.getAttribute("data-title")}</h2>`);
        } 
    }

    if (recentlyViewedHtml.length > 0) {
        const newProductData = `${recentlyViewedHtml.join("")}`;
        const fullContent = document.getElementsByClassName("js-recently-viewed");
        fullContent[0].innerHTML = newProductData;
    }
}

getRecentlyViewedProducts();


// carousel loader
const mountSplide = () => {
    const splide = new Splide( '#splide-recently-viewed', {
        type: 'loop',
        snap: true,
        perPage: 4,
        gap: '1.6rem',
        breakpoints: {
            990: {
                perPage: 3,
                gap: '1rem',
            },
            600: {
                perPage: 2,
                gap: '1.2rem',
            },
            440: {
                perPage: 2,
                gap: '1rem',
            }
        },
    });

    splide.on( 'overflow', function ( isOverflow ) {
        splide.options = {
        arrows    : isOverflow,
        pagination: isOverflow,
        drag      : isOverflow,
        clones    : isOverflow ? 2 : 0
        };
    } );

    splide.mount();
    }

// 100ms delay
setTimeout(() => mountSplide(), 200);

// {% comment %} reload section on editor update - https://shopify.dev/themes/architecture/sections/integrate-sections-with-the-theme-editor {% endcomment %}
document.addEventListener('shopify:section:load', () => mountSplide()); 